<div class="login-page vh-100">

  <div class="container-fluid h-100">
    <div class="row h-100 g-0">

      <!-- ================= LEFT: LOGIN ================== -->
      <div class="col-lg-5 col-md-6 login-section">

        <div class="login-box">

          <div class="brand text-center">
            <img src="assets/logo.png" class="brand-logo" />
            <h5>Login to <span class="highlight">SiDrive</span></h5>
          </div>

          <form (ngSubmit)="onLogin()" #loginForm="ngForm" novalidate class="login-form">

            <div class="form-group">
              <label>User ID</label>
              <input type="text" class="form-control" placeholder="Enter your user ID" name="userid"
                [(ngModel)]="loginData.loginId" autocomplete="username" required />
            </div>

            <div class="form-group">
              <label>Password</label>
              <input type="password" class="form-control" placeholder="Enter your password" name="password"
                [(ngModel)]="loginData.password" autocomplete="new-password" required />
            </div>

            <button class="btn login-btn w-100" type="submit" [disabled]="!loginForm.form.valid">
              Login
            </button>

            <div *ngIf="errorMessage" class="alert alert-danger mt-3 text-center">
              {{ errorMessage }}
            </div>

          </form>

          <div class="footer-note text-center">
            <p>© 2025 SiDrive Simulation Systems</p>
          </div>

        </div>
      </div>

      <!-- ================= RIGHT: LANDING ================== -->
      <div class="col-lg-7 col-md-6 landing-section">

        <div class="landing-overlay">

          <!-- ====== HEADER ====== -->
          <div class="top-text">
            <h1>
              Welcome to
              <span class="highlight">SiDrive</span>
            </h1>

            <p class="subheading">
              Use your credentials to log in and access your dashboard.
            </p>
          </div>

          <!-- ====== TABS ====== -->
          <ul class="nav nav-tabs prod-tabs">

            <li class="nav-item" *ngFor="let tab of tabs">
              <a class="nav-link" [class.active]="selectedTab === tab" href="javascript:void(0)"
                (click)="selectTab(tab)">
                {{ tab }}
              </a>
            </li>

          </ul>

          <!-- ====== CONTENT ====== -->
          <div class="content-area">

            <!-- Instructions -->
            <div *ngIf="selectedTab === 'Instructions'">
              <h4>Instructions</h4>
              <p>Welcome to SiDrive! Use your credentials to log in and access your dashboard.</p>
              <ul>
                <li>Make sure that you enter all details</li>
                <li>Save as frequently as you can.</li>
                <li>Ask facilitator if you have doubts</li>
              </ul>
            </div>

            <!-- About Simulation -->
            <div *ngIf="selectedTab === 'About Simulation'">
              <h4>About Simulation</h4>
              <p>
                SiDrive offers realistic simulation environments that help
                learners and professionals enhance their skills through
                experiential learning.
              </p>
            </div>

            <!-- About Company -->
            <div *ngIf="selectedTab === 'About Company'">
              <h4>About Our Company</h4>
              <p>
                We are a technology-driven company focused on simulation-based
                learning and innovation in education.
              </p>
            </div>

            <!-- FAQ -->
            <div *ngIf="selectedTab === 'FAQ'">
              <h4>Frequently Asked Questions</h4>

              <p>
                <strong>Q:</strong> How do I reset my password?<br />
                <strong>A:</strong> Contact your administrator.
              </p>

              <p>
                <strong>Q:</strong> How do I join a batch?<br />
                <strong>A:</strong> Faculty assigns batches to users.
              </p>
            </div>

            <!-- Contact -->
            <div *ngIf="selectedTab === 'Contact'">
              <h4>Contact Us</h4>

              <p>
                Email:
                <a href="mailto:support@ene-masterclass.com">
                  support&#64;ene-masterclass.com
                </a>
              </p>

              <p>
                Phone: +98226 13273
              </p>
            </div>

          </div>

        </div>
      </div>

    </div>
  </div>

</div>